import {radio2, setSession, getSession} from '../../tools/config'

let obj = {
    state: {
        radio: {
            radio: 'first'
        },



    },
    mutations: {


        //服务工单
        setRadio2(state, info) {
            setSession(radio2, info)
            state.radio = info
        },
        resetRadio2(state) {
            setSession(radio2, {
                radio: 'first'
            }),
                state.radio = {
                    radio: 'first'
                }
        },

    },
    getters: {

        getRadio2(state) {
            state.radio = getSession(radio2)
            return state.radio
        },

    }
}

export default obj



// WEBPACK FOOTER //
// ./src/store/modules/radio2.js